/** may work not properrly
 *
 * loading images each time after take some changes on code
*/
import { useDrop } from 'react-dnd'
import { NativeTypes } from 'react-dnd-html5-backend'
import { Row } from 'react-bootstrap';
import { Bucket } from 'react-bootstrap-icons';
import styles from '../Shop.module.css'

const BlobToImage = (props) => {
  const { onDrop, onClick } = props;
  const [{ canDrop, isOver }, drop] = useDrop(
    () => ({
      accept: [NativeTypes.FILE],
      drop(item) {
        if (onDrop) {
          onDrop(item)
        }
      },
      canDrop(item) {
        // console.log('canDrop', item.files, item.items)
        return true
      },
      hover(item) {
        // console.log(item)
        // console.log('hover', item.files[0], item.items)
      },
      collect: (monitor) => {
        const item = monitor.getItem()
        if (item) {
          // console.log('collect', item.files[0], item.items)
        }
        return {
          isOver: monitor.isOver(),
          canDrop: monitor.canDrop(),
        }
      },
    }),
    [props],
  )
  const isActive = canDrop && isOver

  return (
    props.images?.length ? <Row className='g-1 mb-3' ref={drop}>
      {props.images.map((img, i) => {
        return (
          <div key={img.id} className={`${styles.productImage} ${i == 0 ? `col-12 ${styles['col-12']}` : `col-6 ${styles['col-6']}`}`}>
            <div className='border rounded w-100 h-100  d-flex align-items-center position-relative'>
              <img className={`w-100`} src={img.src} onClick={onClick}/>
              <div className={`${styles.removeImage} text-danger bg-white p-1 rounded lh-1`}>
                <Bucket size={16} onClick={() => props.onImageDelete?.(img)}/>
              </div>
            </div>
          </div>
        )
      })}
    </Row> :
    <></>
  )
}

export default BlobToImage;